import {
  UmpireTopAndBottomPerformanceChartConfigDto,
  UmpireReportForAdminChartConfigDto,
  UmpirePerformanceBy,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const UmpireTopAndBottomPerformanceChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<UmpireTopAndBottomPerformanceChartConfigDto, UmpireReportForAdminChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('UmpireTopAndBottomPerformanceChart', chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('ShowUmpirePerformanceBy')}
        options={['OverallAccuracy', 'CalledStrikeAccuracy', 'CalledBallAccuracy'] satisfies UmpirePerformanceBy[]}
        selected={chartConfig.umpirePerformanceBy}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            umpireReportTopAndBottomPerformanceChartConfig: {
              ...tempLayout.umpireReportTopAndBottomPerformanceChartConfig,
              umpirePerformanceBy: selected,
            },
          })
        }
        disabled={false}
        useShortLabels={true}
      />
    </div>
  );
};

export default UmpireTopAndBottomPerformanceChartSidebar;
